import * as React from 'react';

import { Helmet } from 'react-helmet-async';
import { useLoaderData } from 'react-router-dom';

import { CatalogFormContext } from 'context';
import type { Catalog as CatalogConfig, ComponentMode } from 'types';

import { CatalogForm, CatalogHeader } from './components';

type CatalogProps = {
  mode: ComponentMode;
};

export default function Catalog({ mode }: CatalogProps) {
  const data = useLoaderData() as CatalogConfig | undefined;

  const { brand } = data ?? {};
  const { title: catalogBrandTitle } = brand ?? {};
  const isUpdatedMode = mode === 'Update';

  const step = 1;
  const title = isUpdatedMode ? catalogBrandTitle : 'افزودن کاتالوگ جدید';
  const defaultTitle = isUpdatedMode ? catalogBrandTitle : '';

  return (
    <React.Fragment>
      <Helmet>
        <title>{`${title} | کاشی لند`}</title>
      </Helmet>
      <CatalogHeader>{title}</CatalogHeader>
      <CatalogFormContext
        mode={mode}
        step={step}
        defaultTitle={defaultTitle}
        ownerType='Catalog'
        {...(isUpdatedMode ? data : {})}
      >
        <CatalogForm />
      </CatalogFormContext>
    </React.Fragment>
  );
}
